{
  "title": "Connect my mobile app",
  "form": {
    "mobileApp": {
      "label": "Select the application of your choice to generate the QR code",
      "placeholder": "Select an application",
      "validation": {
        "required": "You must select a mobile application"
      }
    },
    "button": {
      "content": "Generate QR code"
    }
  },
  "qrCode": {
    "expirationDate": "Expires on"
  },
  "downloadOfflineAccess": {
    "button": "Download configuration for offline access"
  },
  "passwordModal": {
    "password": {
      "validation": {
        "pattern": "The password must be at least 12 characters long, including upper and lower case letters, numbers and special characters",
        "required": "You must enter a password"
      },
      "label": "Password"
    },
    "title": "Enter the password provided by the My LogUp application"
  }
}
